import Modal from "views/components/modal";
import type { ModalButton } from "views/components/modal/Modal";
import style from "./style.module.css";
import { merge } from "lib/lodash";
import composeClassName from "lib/composeClassName";

interface ButtonsDetails {
  /** Overrides merged over the default "Ok" button. */
  ok?: Partial<ModalButton>;
  /** Overrides merged over the default "Cancel" button. */
  cancel?: Partial<ModalButton>;
  buttonsClassName?: string;
  crossClassName?: string;
}

interface ConfirmationModalProps {
  modalClassName?: string;
  isOpen?: boolean;
  onCloseModal: () => void;
  header?: string;
  /** Rendered as raw HTML. */
  text?: string;
  onOk: () => void;
  onCancel: () => void;
  buttonsDetails?: ButtonsDetails;
}

const ConfirmationModal = ({
  modalClassName,
  isOpen,
  onCloseModal,
  header,
  text,
  onOk,
  onCancel,
  buttonsDetails = {}
}: ConfirmationModalProps) => {
  const onOkClick = () => {
    onOk();
    onCloseModal();
  };

  const onCancelClick = () => {
    onCancel();
    onCloseModal();
  };

  const defaultOkButton: ModalButton = {
    name: "Ok",
    theme: "blueSolid",
    onClick: onOkClick
  };

  const defaultCancelButton: ModalButton = {
    name: "Cancel",
    theme: "gray",
    onClick: onCancelClick
  };

  const buttonsList = [
    merge(defaultCancelButton, buttonsDetails.cancel),
    merge(defaultOkButton, buttonsDetails.ok)
  ];

  return (
    <Modal
      className={composeClassName("confirmationModal", style, modalClassName)}
      isOpen={isOpen}
      contentLabel="Upgrade to Plan"
      onRequestClose={onCloseModal}
      header={header}
      buttons={buttonsList}
      buttonsClassName={buttonsDetails.buttonsClassName}
      crossClassName={buttonsDetails.crossClassName}
    >
      <div className={composeClassName("confirmationModalContent", style)}>
        <div dangerouslySetInnerHTML={{ __html: text ?? "" }} />
      </div>
    </Modal>
  );
};

ConfirmationModal.displayName = "ConfirmationModal";

export default ConfirmationModal;
